import * as React from "react";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import DangerousIcon from "@mui/icons-material/Dangerous";

import "../snowreport.css";

interface IconContainerProps extends React.HTMLAttributes<HTMLSpanElement> {
  value: number;
  fontSize?: string;
}

const customIcons = (fontSize?: string) => ({
  1: {
    icon: <InfoIcon color="success" style={{ fontSize }} />,
  },
  2: {
    icon: <WarningIcon color="warning" style={{ fontSize }} />,
  },
  3: {
    icon: <DangerousIcon color="error" style={{ fontSize }} />,
  },
});

function IconContainer({ value, fontSize, ...other }: IconContainerProps) {
  return <span {...other}>{customIcons(fontSize)[value]?.icon}</span>;
}

interface GOMRatingProps {
  value: number;
  label?: string;
  fontSize?: string;
  iconFontSize?: string;
}

export default function GOMRating({
  value,
  label,
  fontSize = "16px",
  iconFontSize = "2.0rem",
}: GOMRatingProps) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <IconContainer value={value} fontSize={iconFontSize} />
      <span
        style={{
          marginLeft: "0.2rem",
          fontSize: fontSize,
          fontWeight: "bold",
          fontFamily: "Ubuntu",
        }}
      >
        {label}
      </span>
    </div>
  );
}
